/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Pit_TitleInputs */

const en_minifier_pit_title = /** @type {(inputs: Minifier_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common Pitfalls`)
};

const ko_minifier_pit_title = /** @type {(inputs: Minifier_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자주 겪는 함정`)
};

const ja_minifier_pit_title = /** @type {(inputs: Minifier_Pit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よくある落とし穴`)
};

/**
* | output |
* | --- |
* | "Common Pitfalls" |
*
* @param {Minifier_Pit_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_pit_title = /** @type {((inputs?: Minifier_Pit_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Pit_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_pit_title(inputs)
	if (locale === "ko") return ko_minifier_pit_title(inputs)
	return ja_minifier_pit_title(inputs)
});